import Helper from '../../../models/Helper';

const URI = '/users/:id/followed-path';

/**
 * @desc Helper for users followed path.
 */
class FollowedPathHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Get path followed by given user.
   * @param {Number} userId Id of the user to get followed path.
   * @return {Promise<PathWithUserInformation>} The promise handling the request.
   * @example
   * const userId = 5678;
   * const response = await myClient.helpers.learningActivity.followedPath.get(userId);
   */
  get(userId) {
    return super.get(userId);
  }

  /**
   * @method findProjects
   * @public
   * @desc Find projects of path followed by given user.
   * @param {Number} userId Id of the user to get followed path.
   * @param {String} [learningActivityStatus=''] If provide, request only projects with given
   * learning activity status.
   * @param {String} [evaluatorType=''] If provide, request only projects with given
   * evaluator type.
   * @return {Promise} The promise handling the request.
   * @example
   * const userId = 5678;
   * const response = await myClient.helpers.learningActivity.followedPath.findProjects(userId);
   * @example
   * const userId = 5678;
   * const status = 'in-progress';
   * const evaluatorType = 'mentor';
   * const response = await myClient.helpers.learningActivity
   *                  .followedPath.findProjects(userId, learningActivityStatus, evaluatorType);
   */
  findProjects(userId, learningActivityStatus = '', evaluatorType = '') {
    const filter = {};

    if (learningActivityStatus) {
      filter.learningActivityStatus = learningActivityStatus;
    }

    if (evaluatorType) {
      filter.evaluatorType = evaluatorType;
    }

    const request = super.find(filter, false);
    request.setRouteParam('id', `${userId}`);

    request.url += '/projects';

    return request.execute();
  }
}

export default FollowedPathHelper;
